/*
 *                     NOTICE
 *            COPYRIGHT 2024 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbstractLeafOperandExpressionNodeConverter } from "abreact/expression/ui/editor/impl/model/impl/row/operandValue/converter/AbstractLeafOperandExpressionNodeConverter";
import { LiteralOperandValueImpl } from "abreact/expression/ui/editor/impl/model/impl/row/operandValue/LiteralOperandValueImpl";
import { ExpExpressionNodeNodeTypeEnum } from "abweb/generated/abwebinternal/api/dto/ExpExpressionNode";
import { Assert } from "abweb/utils/Assert";
// import LiteralOperandValue = GuidedExpressionEditor.AbstractModel.AbstractRowModel.LiteralOperandValue;

export class LiteralOperandExpressionNodeConverter extends AbstractLeafOperandExpressionNodeConverter {
  convert(expExpressionNode) {
    Assert.assert(expExpressionNode.nodeType === ExpExpressionNodeNodeTypeEnum.LITERAL);
    return new LiteralOperandValueImpl(this.getStateWithoutNodeType(expExpressionNode));
  }
}
//# sourceMappingURL=LiteralOperandExpressionNodeConverter.js.map
